// Avatar initials: first letter of the first word plus first letter of the
// last word, so "Daily Routine Co." is "DC", never a three-letter "DRC".
// Handles, emails and URLs reduce to their name part first ("@jane" -> "J",
// "https://www.dailyroutine.co/about" -> "D"). Shared by avatar.vue and the
// React port (app/frontend/components/ui/avatar.tsx); `Initials` in
// app/lib/initials.rb is the Ruby twin and must agree with it.
const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;
const BARE_DOMAIN = /^(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,}(?:\/\S*)?$/i;
const EMAIL = /^[^\s@]+@[^\s@]+$/;
// Letters, digits and anything non-ASCII count; "@", "#", "(" and friends do
// not. No `??` or \p{} escapes: webpack 4 parses this file for avatar.vue.
const LEADING_SYMBOLS = /^[^0-9A-Za-z\u00C0-\uFFFF]+/;

export function initials(name) {
  let text = name == null ? "" : String(name).trim();
  if (SCHEME.test(text) || BARE_DOMAIN.test(text)) {
    text = text.replace(SCHEME, "").replace(/^www\./i, "").split(/[/?#:]/)[0].split(".")[0];
  } else if (EMAIL.test(text)) {
    text = text.split("@")[0];
  }
  const words = text
    .split(/[\s._-]+/)
    .map((word) => word.replace(LEADING_SYMBOLS, ""))
    .filter((word) => word.length > 0);
  if (words.length === 0) return "";
  const picked = words.length === 1 ? [words[0]] : [words[0], words[words.length - 1]];
  return picked.map((word) => Array.from(word)[0].toUpperCase()).join("");
}
